import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CadastroInicialSimplificadoComponent } from 'src/app/routes/cadastros/cadastro-inicial-simplificado/cadastro-inicial-simplificado.component';

@Component({
  selector: 'app-escolha-cadastro-empresa',
  templateUrl: './escolha-cadastro-empresa.component.html',
  styleUrls: ['./escolha-cadastro-empresa.component.scss']
})
export class EscolhaCadastroEmpresaComponent implements OnInit {
  selectedMethod: 'automatic' | 'manual' = 'automatic';

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private router: Router
  ) { }

  ngOnInit() {
  }

  selectMethod = (method: 'automatic' | 'manual') => {
    this.selectedMethod = method;
  }

  confirm = () => {
    if (this.selectedMethod === 'automatic') {
      this.activeModal.close('simplified');
    } else {
      this.activeModal.close('route');
    }
  }
}